'use client'

import { Frame } from './ProductionShared'

// Real product footage from the previous homepage: stepping into a Gaussian-splat scene
// to reposition the camera, change the lens and reshoot.
const CAMERA_VIDEO = 'https://reception.martini.film/storage/v1/object/public/public-assets/3-3d-compmp4.mp4'

export function ProductionCamera() {
  return (
    <Frame>
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="block aspect-video w-full object-cover"
        aria-label="Stepping into a 3D scene in Martini to reposition the camera and reshoot"
      >
        <source src={CAMERA_VIDEO} type="video/mp4" />
      </video>
    </Frame>
  )
}
